<template>
    <async-wrapper :data="orderMessages" :loading="async.loading" :error="async.error">
        <template slot="dataComponent">
            <div v-if="orderMessages" class="row">
                <div class="col-xl-12">
                    <div class="card">
                        <div class="card-body">
                            <pagination-table
                                :data="errorMessages || []"
                                :propsToSearch="['message']"
                                searchPlaceholder="Search message text"
                                title="Error Messages"
                            >
                                <template slot="table" slot-scope="scope">
                                    <order-messages-table :data="scope.data || []"></order-messages-table>
                                </template>
                            </pagination-table>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template slot="loadingComponent">
            <i class="fa fa-circle-o-notch fa-2x fa-spin mt-5"></i>
        </template>
        <template slot="errorComponent">
            <p>{{ async.error }}</p>
        </template>
    </async-wrapper>
</template>
<script>
import AsyncWrapper from 'Shared/Wrappers/AsyncWrapper'
import { firebaseObjectToArray } from '@/utils'
import PaginationTable from 'Shared/Tables/PaginationTable'
import OrderMessagesTable from 'Shared/Tables/OrderMessagesTable'
import { ORDER_MESSAGE_TYPE } from '@/utils/constants'
export default {
    components: {
        AsyncWrapper,
        PaginationTable,
        OrderMessagesTable
    },
    data() {
        return {
            orderId: this.$route.params.id
        }
    },
    computed: {
        async() {
            return this.$store.getters['orderMessages/GET_ASYNC']
        },
        orderMessages() {
            const messages = this.$store.getters['orderMessages/GET_ORDER_MESSAGES']
            return Object.keys(messages).length > 0 ? messages : false
        },
        errorMessages() {
            return this.orderMessages ? firebaseObjectToArray(this.orderMessages[ORDER_MESSAGE_TYPE.ERROR]) : []
        }
    },
    created() {
        this.$store.dispatch('orderMessages/FETCH_ORDER_MESSAGE_BY_ID', {
            id: this.orderId
        })
    },
    beforeDestroy() {
        this.$store.dispatch('orderMessages/REMOVE_ORDER_MESSAGE_REFERENCE', {
            id: this.orderId
        })
    }
}
</script>
